import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { fetchFieldData as serverFetchFieldData } from 'api/cs.passport';
import {
  loadInProgress,
  receiveSfFieldData,
} from 'containers/FormBuilder/actions';
import { showNotification } from 'containers/NotificationEngine/actions';
import {
  FIELD_NAMES_ADDED,
  FIELD_NAMES_HIDDEN,
  FIELD_OBJECTS_ADDED,
} from 'utils/constants';
import {
  NOTIFICATION_TYPE_ERROR,
  NOTIFICATION_TIMEOUT_NONE,
} from 'containers/NotificationEngine/constants';

export const useFetchSfFieldData = () => {
  const dispatch = useDispatch();

  const fetchFieldData = useCallback(async (salesforceOrg) => {
    if (!salesforceOrg) return;
    dispatch(loadInProgress(true));
    try {
      let fieldResponse = await serverFetchFieldData(salesforceOrg);
      if (fieldResponse) {
        fieldResponse = { ...fieldResponse, ...FIELD_OBJECTS_ADDED };
        const fieldStandardNameToApiNameMap = Object.keys(fieldResponse)
          .filter((fieldName) => !FIELD_NAMES_HIDDEN.includes(fieldName))
          .concat(FIELD_NAMES_ADDED)
          .reduce((map, standardFieldName) => {
            if (fieldResponse[standardFieldName]) {
              map[standardFieldName] = fieldResponse[standardFieldName].apiFieldName; // eslint-disable-line no-param-reassign
            } else {
              map[standardFieldName] = standardFieldName; // eslint-disable-line no-param-reassign
            }
            return map;
          }, {});
        dispatch(receiveSfFieldData(fieldResponse, fieldStandardNameToApiNameMap));
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('[Hook Error] failed to fetch SF field data:', e);
      dispatch(showNotification(
        'passport:err-load-failed',
        NOTIFICATION_TYPE_ERROR,
        'Failed to load field data from Passport',
        NOTIFICATION_TIMEOUT_NONE,
        null,
        null
      ));
    }
    dispatch(loadInProgress(false));
  }, [dispatch]);

  return { fetchFieldData };
};
